import gql from 'graphql-tag';

export const getLead = gql`
  query getLead {
    getLead {
      firstName
      lastName
      annualSalary
      vehicleCondition
      bodyType
      carValue
      leaseTerm
      phoneNumber
      email
    }
  }
`;
